import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, useRoutes } from "react-router-dom";
import "./tailwind.css";
import "./index.css";
import "./polyfills";
import Providers from "../app/providers";
import { routes } from "./routes";
import { CircleLoading } from "components/Loaders";

function AppRoutes() {
  const routeElements = useRoutes(routes);
  return <Suspense fallback={<CircleLoading />}>{routeElements}</Suspense>;
}

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Providers>
      <AppRoutes />
    </Providers>
  </BrowserRouter>,
);
